import { scrollLock, escListener, scrollTo, mediaQueries } from "../utilities/utils"

// Thumbnail -> gallery scroll (for column/grid galleries, where Swiper's
// native `thumbs` linkage isn't active). Matches by media id so it stays
// correct even when variant selection reorders the gallery media.
function setupThumbnailGalleryScroll() {
  document.querySelectorAll(".main-product__media-wrapper").forEach((wrapper) => {
    const thumbnails = wrapper.querySelector(".swiper-thumbnails")
    const gallery = wrapper.querySelector(".main-product__media-gallery swiper-container")

    if (!thumbnails || !gallery) return

    thumbnails.addEventListener("click", (event) => {
      const slide = event
        .composedPath()
        .find((node) => node instanceof Element && node.matches("swiper-slide[data-id]"))

      if (!slide || !thumbnails.contains(slide)) return

      // When the main gallery is an active slider, Swiper's thumbs option
      // already drives navigation, so let it handle the click.
      const isActiveSlider = gallery.swiper && !gallery.swiper.destroyed
      if (isActiveSlider) return

      const mediaId = slide.getAttribute("data-id")
      const target = gallery.querySelector(
        `.main-product__gallery-item[data-id="${mediaId}"]`
      )

      if (target) {
        scrollTo(target, 16)
      }
    })
  })
}

window.addEventListener("load", setupThumbnailGalleryScroll)

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", setupThumbnailGalleryScroll)
}

// gallery on click logic

function setSliderOnClick(sliderEl) {
  if (!sliderEl) return

  sliderEl.swiper.on("click", function () {
    const slides = this.virtual.slides.length > 0 ? this.virtual.slides : this.slides;
    if (slides[this.clickedIndex].getAttribute("data-id")) {
      if (
        !slides[this.clickedIndex].classList.contains("model") &&
        !slides[this.clickedIndex].classList.contains("video")
      ) {
        openLightBox(slides[this.clickedIndex].getAttribute("data-id"))
      }
    }
  })
}

function setGridOnClick(galleryEl) {
  if (!galleryEl) return

  galleryEl.querySelectorAll("figure:not(.figure--model)").forEach((figure) => {
    figure.addEventListener("click", () => {
      openLightBox(figure.parentNode.getAttribute("data-id"))
    })
  })
}

function setGalleryMediaOnClick() {
  const productGallery = document.querySelector(".zoom-lightbox")

  if (productGallery && !productGallery.swiper || productGallery.swiper.destroyed == true) {
    setGridOnClick(productGallery)
  } else {
    setSliderOnClick(productGallery)
  }
}

window.addEventListener("load", setGalleryMediaOnClick)

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    // Wait for swiper initialization to complete
    setTimeout(setGalleryMediaOnClick, 100)
  })
}

let lightboxEl, videos = [];

const closeLightBox = () => {
  scrollLock(false)
  escListener(false)
  if (lightboxEl) {
    lightboxEl.classList.remove("pdp-lightbox--open")
  }

  if (videos && videos.length) {
    Array.from(videos).forEach(function (video) {
      if (video.tagName.toLowerCase() === "video") {
        video.pause()
      } else {
        var src = video.src
        video.src = src
      }
    })
  }
}

const jumpToTargetFigure = (id) => {
  lightboxEl.scrollTop =
    lightboxEl.querySelector('figure[data-id="' + id + '"').offsetTop +
    parseInt(getComputedStyle(lightboxEl).paddingTop)
}

const openLightBox = (id) => {
  lightboxEl = document.querySelector(".pdp-lightbox")
  if (lightboxEl) {
    const closeButton = lightboxEl.querySelector(".pdp-lightbox__close")
    videos = lightboxEl.querySelectorAll("iframe, video")

    if (closeButton) {
      closeButton.addEventListener("click", () => {
        closeLightBox()
      })
    }

    lightboxEl.querySelectorAll(".figure--image").forEach((image) => {
      image.addEventListener("click", closeLightBox)
    })
  }
  scrollLock(true)
  escListener(true, closeLightBox)
  lightboxEl.classList.add("pdp-lightbox--open")
  jumpToTargetFigure(id)
  const closeBtn = lightboxEl.querySelector('.pdp-lightbox__close')
  if (closeBtn) {
    closeBtn.removeAttribute('disabled')
  }
}

export { openLightBox }

// Sticky Add to Cart
function enableStickyAddToCart() {
  const stickyBar = document.querySelector(".sticky-add-to-cart")
  const mainATC = document.querySelector(".main-product__add-to-cart .button--add-to-cart")
  const mainProductSection = document.querySelector("section.main-product")
  const footer = document.querySelector(".footer-sections")

  if (!stickyBar || !mainATC) return

  // Hide sticky bar initially
  stickyBar.classList.remove("active")

  let isFooterVisible = false
  let isATCVisible = true
  let sectionBottomCleared = false

  const updateStickyBar = () => {
    const isDesktop = mediaQueries.isLargeUp.matches
    const shouldShow = isFooterVisible
      ? false
      : isDesktop
        ? sectionBottomCleared
        : !isATCVisible

    if (shouldShow) {
      stickyBar.classList.add("active")
    } else {
      stickyBar.classList.remove("active")
    }
  }

  const checkSectionBottomCleared = () => {
    if (!mainProductSection) return
    const stickyZoneFromBottom = stickyBar.offsetHeight + 16
    const sectionRect = mainProductSection.getBoundingClientRect()
    sectionBottomCleared = sectionRect.bottom <= window.innerHeight - stickyZoneFromBottom
    updateStickyBar()
  }

  // On desktop: show sticky only when section bottom has scrolled above the sticky zone (no overlap)
  let scrollTicking = false
  const onScrollOrResize = () => {
    if (scrollTicking) return
    scrollTicking = true
    requestAnimationFrame(() => {
      if (mediaQueries.isLargeUp.matches) checkSectionBottomCleared()
      else updateStickyBar()
      scrollTicking = false
    })
  }

  if (mainProductSection) {
    window.addEventListener("scroll", onScrollOrResize, { passive: true })
    window.addEventListener("resize", onScrollOrResize)
    checkSectionBottomCleared()
  }

  // Observer for footer - hide sticky bar when footer enters viewport
  if (footer) {
    const footerObserver = new window.IntersectionObserver(
      ([entry]) => {
        isFooterVisible = entry.isIntersecting
        updateStickyBar()
      },
      {
        root: null,
        threshold: 0,
        rootMargin: "0px 0px -100px 0px",
      }
    )
    footerObserver.observe(footer)
  }

  // Observer for main ATC button - show sticky bar when scrolled past (mobile only)
  const atcObserver = new window.IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        isATCVisible = true
      } else {
        isATCVisible = entry.boundingClientRect.top > 0
      }
      updateStickyBar()
    },
    {
      root: null,
      threshold: 0,
    }
  )
  atcObserver.observe(mainATC)

  // Scroll to ATC functionality
  const scrollATC = document.querySelectorAll(".scroll-atc")
  if (scrollATC) {
    scrollATC.forEach((button) => {
      button.addEventListener("click", function (e) {
        const elem = document.querySelector(".main-product__add-to-cart")
        const variantSelects = document.querySelector(".main-product__variant-selector")

        const scrollToElement = variantSelects || elem

        if (scrollToElement) {
          const rect = scrollToElement.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          // Scroll so the element appears 200px below the top of the viewport
          const scrollY = rect.top + scrollTop - 200;

          window.scrollTo({
            top: scrollY,
            behavior: 'smooth'
          });
        }

        if (variantSelects) {
          setTimeout(function() {
            variantSelects.classList.add('ux-shake');
            setTimeout(function() {
              variantSelects.classList.remove('ux-shake');
            }, 800);
          }, 800);
        }
      })
    })
  }
}

window.addEventListener("load", enableStickyAddToCart)

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", enableStickyAddToCart)
}